import React, { useState, useEffect } from 'react';
import { ENV } from '../../config/config';
import { useGetRoleQuery } from "../../redux/api";
import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";
import { useGetDocumentsQuery, useCreateDocumentMutation, useDeleteDocumentMutation } from '../../redux/api';
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import localeInfo from 'rc-pagination/lib/locale/en_US';
import { Button, Card, Form, Table, Container, Row, Col, OverlayTrigger, Tooltip, Modal } from "react-bootstrap";
import { FaPlus, FaCopy, FaTrash } from "react-icons/fa";
import { toast } from 'react-toastify'
import Swal from 'sweetalert2';
import { useSelector, useDispatch } from 'react-redux';
import DocumentModal from './documentModal';
import validator from 'validator';
var CryptoJS = require("crypto-js");
const { objectToQueryString, decimalNumberValidator } = ENV

const Documents = () => {

    // const dispatch = useDispatch()
    const [qs, setQs] = useState('')
    const { data: documentsData, isLoading: isDocumentsLoading, isFetching: isDocumentsFetching, refetch } = useGetDocumentsQuery(qs)
    const [createDocumentMut, { isLoading: isCreatingDocument }] = useCreateDocumentMutation()
    const [deleteDocumentMut, { isLoading: isDeletingDocument }] = useDeleteDocumentMutation()
    const [documents, setDocuments] = useState([])
    const [document, setDocument] = useState()
    const [documentErrors, setDocumentErrors] = useState()
    const [pagination, setPagination] = useState(null)
    const [resetButton, setResetButton] = useState(false)
    const [permissions, setPermissions] = useState({})
    const isGlobalLoading = isDocumentsLoading || isDocumentsFetching || isCreatingDocument || isDeletingDocument;
    const [filters, setFilters] = useState({
        name: ''
    })
    const [openModal, setOpenModal] = useState(false)

    const { error } = useSelector((state) => state.error)
    // const rolesSelector = useSelector((state) => state.role.getRoleRes)
    // const documentsSelector = useSelector(state => state.documents);

    useEffect(() => {
        window.scroll(0, 0)

        if (localStorage.getItem('userID')) {
            // query runs automatically
        }
    }, [])
    const roleEncrypted = localStorage.getItem("role");
    const roleDecrypted = roleEncrypted
        ? CryptoJS.AES.decrypt(roleEncrypted, ENV.secretKey).toString(
            CryptoJS.enc.Utf8
        )
        : "";
    const { data: roleData } = useGetRoleQuery(roleDecrypted, { skip: !roleEncrypted });

    useEffect(() => {
        if (roleData && roleData.role?.permissions) {
            if (typeof roleData.role.permissions === 'string') {
                setPermissions(JSON.parse(roleData.role.permissions));
            } else {
                setPermissions(roleData.role.permissions);
            }
        }
    }, [roleData]);

    // Removed manual loader handling - RTK manages loading

    useEffect(() => {
        if (documentsData) {
            const docs = documentsData.documents ?? documentsData.data ?? documentsData;
            const pag = documentsData.pagination ?? null;
            setDocuments(docs)
            setPagination(pag)
        }
    }, [documentsData])

    useEffect(() => {
        if (!isDocumentsLoading && qs) {
            refetch()
        }
    }, [isDocumentsLoading])

    // list refetch handled by invalidatesTags

    const onPageChange = async (page) => {
        const queryString = objectToQueryString({ page, ...filters })
        setQs(queryString)
    }

    const applyFilters = () => {
        if (filters && (filters.name)) {
            setResetButton(true)
            const queryString = objectToQueryString({ page: 1, limit: 10, ...filters })
            setQs(queryString)
        }
        else {
            toast.error('Search fields are empty.', {
                toastId: "FIELD_REQUIRED",
            })
        }
    }

    const deleteHandler = (catId) => {
        Swal.fire({
            title: 'Are you sure you want to delete?',
            html: 'If you delete an item, it will lost permanently.',
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Delete'
        }).then(async (result) => {
            if (result.value) {
                (async () => {
                    await deleteDocumentMut(catId)
                })()
            }
        })
    }

    const reset = () => {
        setResetButton(false)
        setFilters({ name: '' })
        setQs('')
    }

    const resetModalContent = () => {
        setDocument();
        setDocumentErrors();
    }
    const modalCloseHandler = () => {
        setOpenModal(!openModal)
        resetModalContent()
    }

    const submit = () => {
        let isValid = true;

        isValid &= document && document !== "" ? true : false;

        if (!isValid) {
            setDocumentErrors("This field is required.");
        } else {
            console.log("Document: ", document);
         var formData = new FormData();
        formData.append('file', document);
        (async () => {
            await createDocumentMut(formData);
        })();
        }
    }

    const copyToClipboard = async (url) => {
        try {
            await navigator.clipboard.writeText(url);
            toast.success("Url copied successfully!")

        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    };

    if (isGlobalLoading) {
        return <FullPageLoader />;
    }

    return (
        <>
            <Container fluid>

                        <Row className="pb-3">
                            <Col sm={12}>
                                <Card className="filter-card">
                                    <Card.Header>
                                        <div className="d-flex align-items-center justify-content-between table-head">
                                            <Card.Title as="h4">Filters</Card.Title>
                                        </div>
                                    </Card.Header>
                                    <Card.Body>
                                        <Row>
                                            <Col xl={4} sm={6}>
                                                <Form.Group>
                                                    <label>Search with name...</label>
                                                    <Form.Control value={filters.name} type="text" placeholder="Search with name..." onChange={(e) => setFilters({ ...filters, name: e.target.value })} />
                                                </Form.Group>
                                            </Col>

                                            <Col xl={4} md={6}>
                                                <Form.Group>
                                                    <Form.Label className="d-block mb-2">&nbsp;</Form.Label>
                                                    <div className="d-flex  filter-btns-holder">
                                                        <Button className="btn-filled mr-3" onClick={applyFilters}>Search</Button>
                                                        {resetButton && <Button variant="warning" className='outline-button' onClick={reset}>Reset</Button>}
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col md="12">
                                <Card className="table-big-boy">
                                    <Card.Header>
                                        <div className="d-flex align-items-center justify-content-between table-head">
                                            <Card.Title as="h4">Documents</Card.Title>
                                            {
                                                permissions && permissions.addDocument &&
                                                <Button
                                                    className="float-sm-right btn-filled d-flex align-items-center"
                                                    onClick={() => {
                                                        resetModalContent()
                                                        setOpenModal(true)
                                                    }}
                                                >
                                                    <span className='add-icon mr-2'>
                                                        <FaPlus />
                                                    </span>
                                                    Add Document
                                                </Button>

                                            }
                                        </div>
                                    </Card.Header>
                                    <Card.Body className="table-full-width">
                                        <div className="table-responsive">
                                            <Table className="table-bigboy">
                                                <thead>
                                                    <tr>
                                                        <th className="text-center td-start">#</th>
                                                        <th className='td-type'>Name</th>
                                                        <th className='td-type'>Url</th>
                                                        <th className="td-actions text-center">Actions</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                            documents && documents.length ?
                                                            documents.map((document, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <td className="text-center serial-col ">{pagination && ((pagination.limit * pagination.page) - pagination.limit) + index + 1}</td>
                                                                        <td className=' td-type'>
                                                                            {document.name}
                                                                        </td>
                                                                        <td className=' td-type'>
                                                                            {ENV.assetsUrl +"documents/"+ document?.url}
                                                                        </td>
                                                                        <td className="td-actions text-center">
                                                                            <ul className="list-unstyled mb-0">
                                                                                <li className="d-inline-block align-top">
                                                                                    <OverlayTrigger overlay={<Tooltip id="tooltip-436082023"> Copy Url </Tooltip>} placement="left" >
                                                                                        <Button
                                                                                            className="btn-link btn-icon"
                                                                                            type="button"
                                                                                            variant="success"
                                                                                            onClick={() => { copyToClipboard(ENV.assetsUrl +"documents/"+document?.url) }}
                                                                                        >
                                                                                            <FaCopy />
                                                                                        </Button>
                                                                                    </OverlayTrigger>
                                                                                </li>
                                                                                {
                                                                                    permissions && permissions.deleteDocument &&
                                                                                    <li className="d-inline-block align-top">
                                                                                        <OverlayTrigger overlay={<Tooltip id="tooltip-436082023">Delete</Tooltip>} placement="left">
                                                                                            <button type="button" className="btn-link btn-icon btn btn-danger" onClick={() => { deleteHandler(document.id) }}><FaTrash /></button>
                                                                                        </OverlayTrigger>
                                                                                    </li>
                                                                                }
                                                                            </ul>
                                                                        </td>

                                                                    </tr>

                                                                )
                                                            })
                                                            :
                                                            <tr>
                                                                <td colSpan="13" className="text-center">
                                                                    <div className="alert alert-info" role="alert">No Document Found</div>
                                                                </td>
                                                            </tr>
                                                    }
                                                </tbody>
                                            </Table>
                                            {
                                                pagination &&
                                                <Pagination
                                                    className="m-3"
                                                    defaultCurrent={1}
                                                    pageSize // items per page
                                                    current={pagination.page} // current active page
                                                    total={pagination.pages} // total pages
                                                    onChange={onPageChange}
                                                    locale={localeInfo}
                                                />
                                            }
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        <DocumentModal
                            modalCloseHandler={modalCloseHandler}
                            openModal={openModal}
                            setOpenModal={setOpenModal}
                            document={document}
                            setDocument={setDocument}
                            submit={submit}
                            documentErrors={documentErrors}
                            setDocumentErrors={setDocumentErrors}
                        />

                    </Container>
        </>
    )
}

export default Documents;
